const getApiHost = () => {
  const { hostname } = window.location;
  if (hostname === 'localhost') {
    return 'http://localhost:8000';
  } else if (hostname === 'pineapplemusiclab.com') {
    return 'https://auto-fingering-api-prod.azurewebsites.net';
  } else {
    return 'https://auto-fingering-api-dev.azurewebsites.net';
  }
};

export { getApiHost };
